var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"synap",rawName:"v-synap:loaded",value:(_vm.handleLoaded),expression:"handleLoaded",arg:"loaded"}],class:['form-control-container', 'synap-editor-wrapper', _vm.mode],attrs:{"id":_vm.editorId}})
}
var staticRenderFns = []

export { render, staticRenderFns }